module.exports = __webpack_public_path__ + "static/media/LogoEN.5f19511f.svg";